"use strict";function keepAlive$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.keepAlive$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="media.voiceRecorder.keepAlive";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.12"},_a)),exports.keepAlive$=keepAlive$,exports.default=keepAlive$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/media/voiceRecorder/keepAlive.js
// module id = 1080
// module chunks = 106